import * as React from "react";
const SvgFiRrGramophone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-gramophone_svg__a)">
      <path
        fill="#062147"
        d="M23 22h-1v-1c0-2.206-1.794-4-4-4h-2v-1c0-1.103.897-2 2-2h2c2.206 0 4-1.794 4-4s-1.794-4-4-4h-2.776c-.811-.242-5.597-1.778-9.202-5.323C7.358.024 6.399-.155 5.521.214A2.46 2.46 0 0 0 4 2.478v9.196c0 .957.578 1.818 1.473 2.195.295.124.599.185.898.185.565 0 1.11-.217 1.533-.631 3.711-3.635 8.509-5.18 9.32-5.422H20c1.103 0 2 .897 2 2s-.897 2-2 2h-2c-2.206 0-4 1.794-4 4v1H6c-2.206 0-4 1.794-4 4v1H1a1 1 0 0 0 0 2h22A1 1 0 0 0 23 22M6.504 11.994c-.029.028-.099.097-.256.032-.115-.048-.248-.17-.248-.351V2.478c0-.218.159-.362.295-.42a.4.4 0 0 1 .146-.032c.101 0 .156.055.179.077 2.498 2.457 5.442 4.013 7.526 4.899-2.096.896-5.074 2.476-7.642 4.992M4 21c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2v1H4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-gramophone_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGramophone;
